"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const mobx_react_1 = require("mobx-react");
require("./index.scss");
const contexts_1 = require("@App/contexts");
const react_hook_form_1 = require("react-hook-form");
const zod_1 = require("@hookform/resolvers/zod");
const InnerForm_1 = __importDefault(require("@Fields/v2/InnerForm"));
const SubmitButton_1 = __importDefault(require("@Fields/SubmitButton"));
const creators_1 = require("@App/helpers/work-entities/creators");
const Button_1 = require("@Components/Buttons/Button");
const add_recording_schema_1 = require("@Entities/schemas/wizardFlow/add-recording-schema");
const dayjs_1 = __importDefault(require("dayjs"));
const AddRecording = ({ closePopupFunc }) => {
    const { workStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const methods = (0, react_hook_form_1.useForm)({
        mode: 'onChange',
        criteriaMode: 'all',
        resolver: (0, zod_1.zodResolver)(add_recording_schema_1.addRecordingSchema),
    });
    const addRecordingToDraft = (addRecording) => {
        const workDraftFromLocal = workStore.workDraftLocal;
        if (!workDraftFromLocal) {
            return;
        }
        // The existing data model uses NULL intead of UNDEFINED for some fields, so we adapt to that here, to prevent downstream issues
        const updatedWork = (0, creators_1.createUpdatingWorkDraft)(workDraftFromLocal, 'recordings', Object.assign(Object.assign({}, addRecording), { isrc: addRecording.isrc ? addRecording.isrc : null, releaseDate: addRecording.releaseDate
                ? (0, dayjs_1.default)(addRecording.releaseDate).format('YYYY-MM-DDTHH:mm:ssZ')
                : null, duration: addRecording.duration ? addRecording.duration : null, label: addRecording.label ? addRecording.label : null }));
        workStore.setWorkDraftToLocal(updatedWork);
    };
    return (react_1.default.createElement("div", { className: "recording-sub-form-component" },
        react_1.default.createElement("h2", null, "Add Recording"),
        react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, methods),
            react_1.default.createElement("form", { className: "add-recording-form", onSubmit: methods.handleSubmit((newRecording) => {
                    addRecordingToDraft(newRecording);
                    closePopupFunc();
                }) },
                react_1.default.createElement(InnerForm_1.default, { formFields: add_recording_schema_1.addRecordingFormFields }),
                react_1.default.createElement("div", { className: 'add-recording-button-container' },
                    react_1.default.createElement(Button_1.Button, { type: 'secondary', mainColor: true, disabled: !methods.formState.isValid, onClick: () => __awaiter(void 0, void 0, void 0, function* () {
                            yield methods.handleSubmit(addRecordingToDraft)();
                            methods.reset();
                        }) }, "Save & add another recording"),
                    react_1.default.createElement(SubmitButton_1.default, { label: "Add Recording", disabled: !methods.formState.isValid }))))));
};
exports.default = (0, mobx_react_1.observer)(AddRecording);
